import React from "react";
import "./textBlock.css";
import BtnLink from "../btns/BtnLink";

export default function TextBlock(props, variant, icon, width) {
  return (
    <div className="textBlock">
      <div className="textTitle">
        <h3>{props.title}</h3>
        <hr />
      </div>
      <div className="textContent">
        <p>{props.text}</p>
        <div className={props.class}>
          <BtnLink
            src="/team"
            variant="primary"
            icon
            border
            bg="true"
            width="medium"
          >
            Наша команда
          </BtnLink>
        </div>
      </div>
    </div>
  );
}
